module.exports = __webpack_public_path__ + "static/media/benefitsInvestersIcon03.6b3e6222.svg";